import VerifyIdentityError from 'features/otp/challenges/VerifyIdentity/VerifyIdentityError/VerifyIdentityError';
import React from 'react';

export default function VerifyIdentityErrorScreen() {
  return <VerifyIdentityError />;
}
